export { default as SymposiumSchedule } from './SymposiumSchedule';
